module.exports = __webpack_public_path__ + "img/MobileSelectedFeedbackOkay.e99ced38.png";